import { render, staticRenderFns } from "./VAMethodViz.vue?vue&type=template&id=3c3e0c0a&scoped=true"
import script from "./VAMethodViz.vue?vue&type=script&lang=js"
export * from "./VAMethodViz.vue?vue&type=script&lang=js"
import style0 from "./VAMethodViz.vue?vue&type=style&index=0&id=3c3e0c0a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3e0c0a",
  null
  
)

export default component.exports